export const getPerformances = (state) => state.performances || []

export const getPhotos = (state) => state.photos

export const getPhotoList = (state, id) => getPhotos(state).photos[id]

export const getAlbums = (state) => state.photos.albums

export const getPlayer = (state) => state.player

export const getActiveIndex = (state) => getPlayer(state).activeIndex

export const getShowPlayer = (state) => getPlayer(state).showPlayer




/** WEBPACK FOOTER **
 ** ./src/selectors/selectors.js
 **/